module.exports = __webpack_public_path__ + "static/media/audio_play.04cc1852.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/audio_play.svg
// module id = 707
// module chunks = 0